import type { LegacyHandlers } from '../legacy-mirrored-builder';

type ActionEmailHandlers = Pick<LegacyHandlers, 'createActionEmail' | 'updateActionEmail' | 'deleteActionEmail'>;

// TODO: implement as action emails move to the new model.
export const createLegacyActionEmailHandlers = (): ActionEmailHandlers => ({});
